// src/components/StatBox.jsx
import React from 'react';
import '../styles/PartnerAnalyticsDemo.css';

const StatBox = ({ title, value }) => {
  return (
    <div className="stat-box">
      <h3>{title}</h3>
      <div className="stat-value">{value}</div>
    </div>
  );
};

export default StatBox;